exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#chrome-container,#trello-root{height:100%;position:relative;z-index:1;overflow:hidden}", ""]);

// exports
